export default __webpack_public_path__ + "static/media/loader.icon.3c65cab6.svg";